const mixin = {
    data(){
      return {
          deviceTypesForNew: [],
          electricityId: 999,
          electricityTypes: {
              'single': 1,
              'double': 2,
              'triple': 3
          }
      }
    },
    methods: {
        restructureDeviceTypesForNew(types){
            this.deviceTypesForNew = types.filter(deviceType => deviceType.name.substring(0,2).toLowerCase() !== 'ээ');
            this.deviceTypesForNew.push({
                name: 'ЭЭ',
                id: this.electricityId
            });
        }
    }
};

export default mixin;